var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"width":"100%","height":"100vh","border":"0"},attrs:{"id":"resp-iframe","src":_vm.src},on:{"load":_vm.iframeLoaded}})
}
var staticRenderFns = []

export { render, staticRenderFns }